import React from 'react';

export default function ModulePlaceholderPage({ eyebrow, title, description }) {
  return (
    <div className="module-screen">
      <header className="dashboard-header">
        <div>
          <p className="eyebrow">{eyebrow}</p>
          <h1>{title}</h1>
          <span className="subtle">Module shell is ready. Implementation can follow feature by feature.</span>
        </div>
      </header>

      <section className="module-placeholder-card">
        <h2>Module not implemented yet</h2>
        <p>{description}</p>
      </section>
    </div>
  );
}